
import request from '@/utils/request'
// 获取车辆品牌
export function GetDataBrand (data) {
  return request({
    url: '/car/system/dataBrand',
    method: 'post',
    data
  })
}
// 新增品牌
export function addBrand (data) {
  return request({
    url: '/car/system/addBrand',
    method: 'post',
    data
  })
}
// 編輯
export function updateCarBrand (data) {
  return request({
    url: '/car/system/updateCarBrand',
    method: 'post',
    data
  })
}
// 删除

export function deleteCarBrand (data) {
  return request({
    url: '/car/system/deleteCarBrand',
    method: 'post',
    data
  })
}
//车辆型号
export function GetDataType (data) {
  return request({
    url: '/car/system/dataType',
    method: 'post',
    data
  })
}
//车辆车型
export function GetDataModel (data) {
  return request({
    url: '/car/system/dataModel',
    method: 'post',
    data
  })
}
// 新增
export function addType (data) {
  return request({
    url: '/car/system/addType',
    method: 'post',
    data
  })
}
// 删除车辆型号
export function deleteCarType (data) {
  return request({
    url: '/car/system/deleteCarType',
    method: 'post',
    data
  })
}

export function updateCarType (data) {
  return request({
    url: '/car/system/updateCarType',
    method: 'post',
    data
  })
}
//车辆车型下拉
export function GetDataSelectXing (data) {
  return request({
    url: '/car/system/dataSelectXing',
    method: 'post',
    params: data
  })
}
//车辆型号下拉
export function GetdataSelectCar (params) {
  return request({
    url: '/car/system/dataSelectCar',
    method: 'post',
    params
  })
}
//车辆类型下拉
export function GetdataSelectType (data) {
  return request({
    url: '/car/system/dataSelectCarType',
    method: 'post',
    data
  })
}

//车辆车型增加
export function addModel (data) {
  return request({
    url: '/car/system/addModel',
    method: 'post',
    data
  })
}


//车辆车型编辑
export function updateModel (data) {
  return request({
    url: '/car/system/updateModel',
    method: 'post',
    data
  })
}


//车辆车型删除
export function deleteCarModel (data) {
  return request({
    url: '/car/system/deleteCarModel',
    method: 'post',
    data
  })
}


//车辆车型查询
export function queryDataModel (params) {
  return request({
    url: '/car/system/queryDataModel',
    method: 'post',
    params
  })
}

//车辆型号
export function queryCarTypeData (data) {
  return request({
    url: '/car/system/queryCarTypeData',
    method: 'post',
    params: data
  })
}
